import * as constants from './constants'
import createReducer from 'core/reducer-helper'

const initialState = {
  topics: [],
  categories: [],
  languages: [],
  verticals: [],
  userTopicsSaved: [],
  userTopics: [],
  includeUsedTopics: false,
  allTopics: [],

  addTopicFulfilled: false,
  deleteTopicFulfilled: false,
  rejectTopicFulfilled: false,
  approveTopicFulfilled: false,
  editTopicFulfilled: false
}

const fetchTopicsFulfilled = (state, action) => {
  return {
    ...state,
    topics: action.body,
    topicsPending: false,
    topicsError: false
  }
}

const fetchCategoriesFulfilled = (state, action) => {
  return {
    ...state,
    categories: action.body,
    categoriesPending: false,
    categoriesError: false
  }
}

const fetchLanguagesFulfilled = (state, action) => {
  return {
    ...state,
    languages: action.body,
    languagesPending: false,
    languagesError: false
  }
}

const editTopicFulfilled = (state, action) => {
  return {
    ...state,
    editTopicFulfilled: true,
    allTopics: state.allTopics.map(topic => {
      if (topic.topicId !== action.body.topicId) {
        return topic
      }
      return {
        ...topic,
        ...action.body
      }
    })
  }
}

// const editAllTopicFulfilled = (state, action) => {
//   return {
//     ...state,
//     allTopics: state.allTopics.map(topic => {
//       if (topic.id !== action.body.id) {
//         return topic
//       }
//       return {
//         ...topic,
//         ...action.body
//       }
//     })
//   }
// }

const editCategoryFulfilled = (state, action) => {
  return {
    ...state,
    categories: state.categories.map(category => {
      if (category.id !== action.body.id) {
        return category
      }
      return {
        ...category,
        ...action.body
      }
    })
  }
}

const fetchUserTopicsFulfilled = (state, action) => {
  return {
    ...state,
    userTopicsSaved: action.body,
    userTopics: action.body.filter(topic => topic.topicQuery !== null),
    userTopicsPending: false,
    userTopicsError: false
  }
}

const fetchVerticalsFulfilled = (state, action) => {
  return {
    ...state,
    verticals: action.body,
    verticalsPending: false,
    verticalsError: false
  }
}

const toggleIncludeUsedTopics = state => {
  return {
    ...state,
    userTopics: state.includeUsedTopics
      ? state.userTopicsSaved.filter(topic => topic.topicQuery !== null)
      : state.userTopicsSaved,
    includeUsedTopics: !state.includeUsedTopics
  }
}

const addCategoryFulfilled = (state, action) => {
  return {
    ...state,
    categories: [action.body].concat(state.categories)
  }
}

const deleteCategoryFulFilled = (state, action) => {
  return {
    ...state,
    categories: state.categories.filter(category => category.id !== action.extraArguments.category.id)
  }
}

const addTopicFulfilled = (state, action) => {
  return {
    ...state,
    allTopics: [...state.allTopics, { ...action.body, topicType: 'system' }],
    addTopicFulfilled: true
  }
}

const deleteTopicFulFilled = (state, action) => {
  return {
    ...state,
    allTopics: state.allTopics.filter(topic => topic.topicId !== action.extraArguments.topic.topicId),
    deleteTopicFulfilled: true
  }
}

const fetchAllTopicsFulfilled = (state, action) => {
  return {
    ...state,
    allTopics: action.body,
    allTopicsPending: false,
    allTopicsError: false
  }
}

const approveTopicFulfilled = (state, action) => {
  return {
    ...state,
    approveTopicPending: false,
    approveTopicError: false,
    approveTopicFulfilled: true,
    allTopics: state.allTopics.map(topic => {
      if (topic.topicUsageId !== action.extraArguments.id) {
        return topic
      }
      return {
        ...topic,
        ...action.extraArguments.topic,
        topicCategoryName: action.body.topicCategoryName,
        verticalName: action.body.verticalName,
        topicType: 'system'
      }
    })
  }
}

const rejectTopicFulfilled = (state, action) => {
  return {
    ...state,
    rejectTopicPending: false,
    rejectTopicError: false,
    rejectTopicFulfilled: true,
    allTopics: state.allTopics.map(topic => {
      if (!action.extraArguments.id.includes(topic.topicUsageId)) {
        return topic
      }
      return {
        ...topic,
        topicType: 'rejected'
        // ...action.body
      }
    })
  }
}

export default createReducer(initialState, {
  [constants.FETCH_TOPICS_ERROR]: state => ({ ...state, topicsError: true, topicsPending: false }),
  [constants.FETCH_TOPICS_PENDING]: state => ({ ...state, topicsPending: true, topicsError: false }),
  [constants.FETCH_TOPICS_FULFILLED]: (state, action) => fetchTopicsFulfilled(state, action),

  [constants.FETCH_CATEGORIES_ERROR]: state => ({ ...state, categoriesError: true, categoriesPending: false }),
  [constants.FETCH_CATEGORIES_PENDING]: state => ({ ...state, categoriesPending: true, categoriesError: false }),
  [constants.FETCH_CATEGORIES_FULFILLED]: (state, action) => fetchCategoriesFulfilled(state, action),

  [constants.FETCH_LANGUAGES_ERROR]: state => ({ ...state, languagesError: true, languagesPending: false }),
  [constants.FETCH_LANGUAGES_PENDING]: state => ({ ...state, languagesPending: true, languagesError: false }),
  [constants.FETCH_LANGUAGES_FULFILLED]: (state, action) => fetchLanguagesFulfilled(state, action),

  [constants.FETCH_USER_TOPICS_ERROR]: state => ({ ...state, userTopicsError: true, userTopicsPending: false }),
  [constants.FETCH_USER_TOPICS_PENDING]: state => ({ ...state, userTopicsPending: true, userTopicsError: false }),
  [constants.FETCH_USER_TOPICS_FULFILLED]: (state, action) => fetchUserTopicsFulfilled(state, action),

  [constants.FETCH_VERTICALS_ERROR]: state => ({ ...state, verticalsError: true, verticalsPending: false }),
  [constants.FETCH_VERTICALS_PENDING]: state => ({ ...state, verticalsPending: true, verticalsError: false }),
  [constants.FETCH_VERTICALS_FULFILLED]: (state, action) => fetchVerticalsFulfilled(state, action),

  [constants.FETCH_ALL_TOPICS_ERROR]: state => ({ ...state, allTopicsError: true, allTopicsPending: false }),
  [constants.FETCH_ALL_TOPICS_PENDING]: state => ({ ...state, allTopicsPending: true, allTopicsError: false }),
  [constants.FETCH_ALL_TOPICS_FULFILLED]: (state, action) => fetchAllTopicsFulfilled(state, action),

  [constants.EDIT_TOPIC_PENDING]: state => ({ ...state, editTopicFulfilled: false }),
  [constants.EDIT_TOPIC_FULFILLED]: (state, action) => editTopicFulfilled(state, action),
  [constants.TOGGLE_INCLUDE_USED_TOPICS]: state => toggleIncludeUsedTopics(state),

  [constants.ADD_CATEGORY_FULFILLED]: (state, action) => addCategoryFulfilled(state, action),
  [constants.DELETE_CATEGORY_FULFILLED]: (state, action) => deleteCategoryFulFilled(state, action),
  [constants.EDIT_CATEGORY_FULFILLED]: (state, action) => editCategoryFulfilled(state, action),

  [constants.ADD_TOPIC_PENDING]: state => ({ ...state, addTopicFulfilled: false }),
  [constants.ADD_TOPIC_FULFILLED]: (state, action) => addTopicFulfilled(state, action),

  [constants.DELETE_TOPIC_PENDING]: state => ({ ...state, deleteTopicFulfilled: false }),
  [constants.DELETE_TOPIC_FULFILLED]: (state, action) => deleteTopicFulFilled(state, action),

  [constants.APPROVE_USER_TOPIC_ERROR]: state => ({
    ...state,
    approveTopicError: true,
    approveTopicPending: false,
    approveTopicFulfilled: false
  }),
  [constants.APPROVE_USER_TOPIC_PENDING]: state => ({
    ...state,
    approveTopicPending: true,
    approveTopicError: false,
    approveTopicFulfilled: false
  }),
  [constants.APPROVE_USER_TOPIC_FULFILLED]: (state, action) => approveTopicFulfilled(state, action),

  [constants.REJECT_USER_TOPIC_ERROR]: state => ({
    ...state,
    rejectTopicError: true,
    rejectTopicPending: false,
    rejectTopicFulfilled: false
  }),
  [constants.REJECT_USER_TOPIC_PENDING]: state => ({
    ...state,
    rejectTopicPending: true,
    rejectTopicError: false,
    rejectTopicFulfilled: false
  }),
  [constants.REJECT_USER_TOPIC_FULFILLED]: (state, action) => rejectTopicFulfilled(state, action)
})
